export var selectUserRoot = function (state) { return state.user; };
export var selectUserSystems = function (state) {
    return selectUserRoot(state).systems;
};
export var selectUserActiveSystem = function (state) {
    return selectUserRoot(state).activeSystem;
};
export var selectUserErrors = function (state) {
    return selectUserRoot(state).error;
};
export var selectIsUserDataLoading = function (state) {
    return selectUserRoot(state).isLoading;
};
export var selectActiveFolderId = function (state) {
    return selectUserRoot(state).activeFolderId;
};
export var selectUserId = function (state) { return selectUserRoot(state).userId; };
